import { createFileRoute } from "@tanstack/react-router";
import AdminHowTo from "@/pages/AdminHowTo";

export const Route = createFileRoute("/_authenticated/admin-handleiding")({
  head: () => ({
    meta: [
      { title: "Handleiding voor beheerders | De Hussel App" },
      { name: "description", content: "Stap-voor-stap handleiding voor clubbeheerders van De Hussel App." },
      { property: "og:title", content: "Handleiding voor beheerders | De Hussel App" },
      { property: "og:description", content: "Stap-voor-stap handleiding voor clubbeheerders van De Hussel App." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: AdminHowTo,
});
